'use client'
import React from 'react'
import { MultiValueProps } from 'react-select'
import { Tag } from '../../../atoms'
import { SelectOption } from '../../../../types/SelectInput'

export const MultiValueComponent = (props: MultiValueProps<SelectOption>): JSX.Element => (
    <Tag
        removable={props.isMulti && !props.selectProps.isDisabled && !props.data?.disabled}
        removeClickCallback={props.removeProps.onClick}
        removeMouseDownCallback={props.removeProps.onMouseDown}
        removeTouchEndCallback={props.removeProps.onTouchEnd}
        data-testid="select-input-tag"
    >
        {props.data.label}
    </Tag>
)
